'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.styles = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('../../styles');

var _styles2 = _interopRequireDefault(_styles);

var _tokens = require('../../styles/tokens');

var _Popper = require('./../../Popper');

var _Popper2 = _interopRequireDefault(_Popper);

var _MenuList = require('@material-ui/core/MenuList');

var _MenuList2 = _interopRequireDefault(_MenuList);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
    return {
        paper: {
            padding: 0,
            border: _tokens.borderWidthThin + ' solid ' + theme.palette.grey[400]
        },
        popperPosition: {
            minWidth: '100%'
        },
        menuList: {
            padding: '0'
        }
    };
};

var DropdownPopper = _react2.default.forwardRef(function (props, ref) {
    var classes = props.classes,
        PopperProps = props.PopperProps,
        PaperProps = props.PaperProps,
        buttonRef = props.buttonRef,
        isMenuOpen = props.isMenuOpen,
        onClickHandler = props.onClickHandler;

    // Extract our custom classes so they aren't passed to MUI

    var popperPosition = classes.popperPosition,
        paper = classes.paper,
        menuList = classes.menuList;


    function handleListKeyDown(event) {
        if (event.key === 'Tab' || event.key === 'Escape') {
            onClickHandler(event);
        }
    }

    var getChildren = function getChildren() {
        var items = null;

        if (props.dropdown) {
            items = _react2.default.Children.toArray(props.dropdown).map(function (child, index) {
                if (!_react2.default.isValidElement(child)) {
                    console.warning('Invalid element ', child);
                    return null;
                }

                return _react2.default.cloneElement(child, {
                    handleClose: handleClose.bind(undefined),
                    divider: index < props.dropdown.length - 1
                });
            });
        }

        return items;
    };

    var handleClose = function handleClose(event) {
        onClickHandler(event);
        buttonRef.current.focus();
    };

    return _react2.default.createElement(
        _Popper2.default,
        Object.assign({
            anchorEl: buttonRef.current,
            open: isMenuOpen,
            onClickAway: function onClickAway(event) {
                return onClickHandler(event);
            },
            className: (0, _classnames2.default)(popperPosition, 'eds-dropdown-button-popper'),
            PaperProps: Object.assign({
                'aria-live': 'off',
                classes: { root: paper },
                elevation: 1
            }, PaperProps)

        }, PopperProps, {
            onKeyDown: handleListKeyDown,
            transition: false,
            placement: 'bottom-start',
            disablePortal: true
        }),
        _react2.default.createElement(
            _MenuList2.default,
            { className: menuList, role: 'listbox', autoFocusItem: true, onKeyDown: handleListKeyDown },
            getChildren()
        )
    );
});

exports.default = (0, _styles2.default)(styles)(DropdownPopper);